import { isAndroid, isIOS, isIOS13, isIPad13, isMobile, isTablet } from 'react-device-detect';

export default function useMobileDevice() {
  return isTablet || isAndroid || isMobile || isIOS || isIOS13 || isIPad13;
}
